import americanExpress from 'assets/img/mex/logosTarjetas/american_express.png';
import banamex from 'assets/img/mex/logosTarjetas/banamex.png';
import bbva from 'assets/img/mex/logosTarjetas/bbva.png';
import santander from 'assets/img/mex/logosTarjetas/santander.png';

export default {
  TRAVELBTA: [
    {
      src: banamex,
      alt: 'BANAMEX',
    },
    {
      src: santander,
      alt: 'SANTANDER',
    },
    {
      src: americanExpress,
      alt: 'AMEX',
    },
  ],
  APINDIVIDUAL: [
    {
      src: banamex,
      alt: 'BANAMEX',
    },
    {
      src: santander,
      alt: 'SANTANDER',
    },
    {
      src: americanExpress,
      alt: 'AMEX',
    },
    {
      src: bbva,
      alt: 'BBVA',
    },
  ],
  AUTO: [
    {
      src: banamex,
      alt: 'BANAMEX',
    },
    {
      src: santander,
      alt: 'SANTANDER',
    },
    {
      src: americanExpress,
      alt: 'AMEX',
    },
    {
      src: bbva,
      alt: 'BBVA',
    },
  ],
};

export const TARJETAS_PROPS = {
  visa: {
    typeName: 'visa',
    mask: '9999-9999-9999-9999',
    placeholder: '9999-9999-9999-9999',
    length: 16,
  },
  mastercard: {
    typeName: 'mastercard',
    mask: '9999-9999-9999-9999',
    placeholder: '9999-9999-9999-9999',
    length: 16,
  },
  amex: {
    typeName: 'amex',
    mask: '9999-999999-99999',
    placeholder: '9999-999999-99999',
    length: 15,
  },
};
